<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>充值审核</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-tabs :value="activeTab" @tab-click="handleDepositTabChange">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="等待中" name="-1"></el-tab-pane>
        <el-tab-pane label="未确认" name="0"></el-tab-pane>
        <el-tab-pane label="充值成功" name="2"></el-tab-pane>
        <el-tab-pane label="充值失败及异常" name="3"></el-tab-pane>
      </el-tabs>
      <div class="page-actions">
        <el-date-picker
          v-model="dataArry"
          type="datetimerange"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        ></el-date-picker>
        <el-input placeholder="请输入账号ID" clearable v-model="userId"
          ><i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>

        <el-input placeholder="请输入所属链" clearable v-model="queryChainType"> </el-input>
        <el-autocomplete
          class="inline-input"
          v-model="selectedCoin"
          :fetch-suggestions="querySearch"
          placeholder="请输入币种"
          @select="handleSelect"
        >
          <i class="el-icon-close el-input__icon" slot="suffix" @click="cleanSearchCoin" style="cursor: pointer"> </i>
        </el-autocomplete>
        <el-input placeholder="充值最小值" v-model="minNum" style="width: 200px"></el-input>
        <el-input placeholder="充值最大值" v-model="maxNum" style="width: 200px"></el-input>
        <el-input placeholder="请输入充值地址" clearable v-model="txToAddress">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入hash值" clearable v-model="hash" @keyup.native.enter="handleSearch">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select
          v-model="rechargeStatus"
          @focus="statusChange1()"
          v-if="rechargeStatusArr.length > 0"
          placeholder="请选择充值状态"
        >
          <el-option v-for="item in rechargeStatusArr" :key="item.value" :label="item.text" :value="item.value"></el-option>
        </el-select>
        <el-select
          v-model="affirmStatus"
          @focus="statusChange2()"
          v-if="affirmStatusArr.length > 0"
          placeholder="请选择确认状态"
        >
          <el-option v-for="item in affirmStatusArr" :key="item.value" :label="item.text" :value="item.value"></el-option>
        </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <audit-list @refresh="getList" :parameter='parameter' :activeTab="activeTab"></audit-list>
    </el-card>
  </div>
</template>
<script>
import "./store";
import { ALL_TOP_UP_STATUS, ALL_SURE_STATUS, ALL_STATUS } from "./constants";

import { mapState, mapMutations, mapActions } from "vuex";
import AuditList from "./components/list";
export default {
  components: {
    AuditList
  },
  data() {
    return {
      selectedCoin: "",
      userId: "",
      minNum: "",
      maxNum: "",
      txToAddress: "",
      hash: "",
      dataArry: [],
      value: "",
      queryChainType: "", //所属链
      rechargeStatus: "", //充值状态
      rechargeStatusArr: [],
      affirmStatusArr: [],
      affirmStatus: "", //确认状态
      currentQueryData: {},
      searstatu:false,
      parameter:{}
    };
  },
  computed: {
    ...mapState("depositAudit", ["activeTab", "chooseCoinType", "allCoins", "pagination"])
    // ...mapState(['userInfo', 'userRights']),
  },
  methods: {
    linkToInfo() {
      this.$router.push("/home/audit/statistic");
    },

    statusChange1() {
      if (this.activeTab !== "all") return false;
      this.rechargeStatus = "";
      this.affirmStatus = "";
      this.currentQueryData = {};
    },
    statusChange2() {
      if (this.activeTab !== "all") return false;
      this.rechargeStatus = "";
      this.affirmStatus = "";
      this.currentQueryData = {};
    },

    rechargeChange(e) {},

    handleDepositTabChange(tab) {
      this.changeTab(tab.name);
      setTimeout(() => {
        if(tab.name === "3") {
          this.rechargeStatus = "充值失败"
          this.currentQueryData = { txStatus: [-1] };
        }
        this.getList(this.currentQueryData);
      }, 888);
    },
    cleanSearchCoin() {
      this.selectedCoin = "";
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.allCoins;
      results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = this.allCoins;
      return tempData => {
        return tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    ...mapMutations("depositAudit", ["changeTab"]),
    ...mapActions("depositAudit", ["list", "listCoinType", "listBillType", "getAllCoins", "changeCoinType"]),
    handleSelect(tab) {
      this.changeTab(tab.name);
    },
    getList(data = {}) {
      let newpag = this.pagination;
      let curr = {}
      if(this.searstatu){
        curr = {...data}
        this.searstatu = false
      }else {
        curr = {...this.currentQueryData}
      }
      this.list({
        startTime: this.dataArry != null ? this.dataArry[0] : null,
        endTime: this.dataArry != null ? this.dataArry[1] : null,
        userId: this.userId,
        chainType: this.queryChainType,
        coinType: this.selectedCoin,
        minNum: this.minNum,
        maxNum: this.maxNum,
        txToAddress: this.txToAddress,
        hash: this.hash,
        ...newpag,
        // ...this.currentQueryData,
        ...curr
      });
    },
    handleSearch() {
      // if (this.rechargeStatusArr[0].value === "s12") {
      //   this.currentQueryData = { txStatus: [-1, 0], txDepositStatus: [2] };
      // }
      this.searstatu=true
      this.getList({page:1,...this.currentQueryData});
      this.parameter = {
        startTime: this.dataArry != null ? this.dataArry[0] : null,
        endTime: this.dataArry != null ? this.dataArry[1] : null,
        userId: this.userId,
        chainType: this.queryChainType,
        coinType: this.selectedCoin,
        minNum: this.minNum,
        maxNum: this.maxNum,
        txToAddress: this.txToAddress,
        hash: this.hash,
        ...this.currentQueryData
      }
    }
  },
  created() {
    this.getAllCoins();
  },
  mounted() {
    setTimeout(() => {
      this.handleSearch();
    }, 500);
  },
  watch: {
    activeTab: {
      handler(val, oldVal) {
        if (val == "all") {
          this.rechargeStatusArr = ALL_TOP_UP_STATUS;
          this.affirmStatusArr = ALL_SURE_STATUS;
          this.rechargeStatus = "";
          this.currentQueryData = {};
        } else if (val == "-1") {
          this.rechargeStatusArr = ALL_TOP_UP_STATUS.slice(2, 4);
          this.rechargeStatusArr.unshift({ value: "s11", text: "全部", queryData: { txStatus: [3, 10], txDepositStatus: [] } });
          this.affirmStatusArr = [];
          this.currentQueryData = { txStatus: [3, 10], txDepositStatus: [] };
        } else if (val == "0") {
          //未确认没有下拉
          this.rechargeStatusArr = [];
          this.affirmStatusArr = [];
          this.currentQueryData = {
            txStatus: [0],
            txDepositStatus: [1]
          };
        } else if (val === "2") {
          //充值成功 没有下拉
          this.rechargeStatusArr = [];
          this.affirmStatusArr = [];
          this.currentQueryData = { txStatus: [0], txDepositStatus: [0] };
        } else if (val == "3") {
          this.rechargeStatusArr = ALL_TOP_UP_STATUS.slice(-2);
          // this.rechargeStatusArr.unshift({ value: "s12", text: "全部", queryData: { txStatus: [-1, 0], txDepositStatus: [2] } });
          this.affirmStatusArr = [];
          this.currentQueryData = { txStatus: [-1], txDepositStatus: [2] };
        }
      },
      immediate: true
    },

    rechargeStatus: {
      handler(val, oldVal) {
        if (val) {
          let currentVal = ALL_STATUS.find(item => {
            return item.value === val;
          });
          this.currentQueryData = { ...currentVal.queryData };
        }
      }
    },
    affirmStatus: {
      handler(val, oldVal) {
        if (val) {
          let currentVal = ALL_STATUS.find(item => {
            return item.value === val;
          });
          this.currentQueryData = { ...currentVal.queryData };
        }
      }
    }
  }
};
</script>
<style lang="less">
.recharge {
  &-message {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    margin-top: 20px;
    background-color: #fff;
  }
  &-item {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    .item {
      padding: 0 70px;
      text-align: center;
    }
  }
  &-info {
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
  }
}
</style>
